import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { useI18n } from "@/i18n";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export function Header() {
  const { t, lang, toggle } = useI18n();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const items = [
    ["solution", "solution"], ["how", "how"], ["vantaggi", "employee"], ["aziende", "corporate"], ["partner", "partner"],
  ];

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-midnight/85 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <button onClick={() => scrollTo("hero")} data-testid="header-logo-btn">
          <Logo dark={!scrolled} />
        </button>

        <nav className="hidden lg:flex items-center gap-9">
          {items.map(([key, id]) => (
            <button
              key={key}
              data-testid={`nav-${key}`}
              onClick={() => scrollTo(id)}
              className={`link-underline text-sm tracking-wide transition-colors duration-300 ${
                scrolled ? "text-cream/80 hover:text-cream" : "text-white/80 hover:text-white"
              }`}
            >
              {t.nav[key]}
            </button>
          ))}
          <Link
            to="/risorse"
            data-testid="nav-risorse"
            className={`link-underline text-sm tracking-wide transition-colors duration-300 ${
              scrolled ? "text-cream/80 hover:text-cream" : "text-white/80 hover:text-white"
            }`}
          >
            {t.nav.risorse}
          </Link>
        </nav>

        <div className="flex items-center gap-4">
          <button
            data-testid="lang-toggle"
            onClick={toggle}
            className={`text-xs tracking-[0.2em] font-medium transition-colors duration-300 ${
              scrolled ? "text-cream/70 hover:text-cream" : "text-white/70 hover:text-white"
            }`}
          >
            {lang === "it" ? "IT / EN" : "EN / IT"}
          </button>
          <button
            data-testid="header-book-btn"
            onClick={() => scrollTo("book")}
            className="hidden sm:inline-flex items-center rounded-full bg-gold px-5 py-2.5 text-xs font-semibold tracking-[0.14em] uppercase text-midnight transition-transform duration-300 hover:scale-[1.04]"
          >
            {t.nav.book}
          </button>
        </div>
      </div>
    </header>
  );
}
